import { render, staticRenderFns } from "../../templates/form/building-form.pug?vue&type=template&id=d15b8232&lang=pug&"
import script from "./BuildingForm.vue?vue&type=script&lang=js&"
export * from "./BuildingForm.vue?vue&type=script&lang=js&"
import style0 from "./BuildingForm.vue?vue&type=style&index=0&id=d15b8232&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports